import {Component} from 'preact';
import styles from "./styles.scss";

const Status = ({requestResult, tryAgainToSubscribe}) => (
    requestResult ? (
        <div className={styles.status}>
            <img src="../../assets/svg/positive.svg" alt="success-icon"/>
            Thanks for the nice addition to our e-mail database. {`<3`}
        </div>
    ) : (
        <div className={styles.status}>
            <img src="../../assets/svg/negative.svg" alt="success-icon"/>
            It's like when you buy the wrong size. The registration has failed. Please try again. <a href="#" onClick={tryAgainToSubscribe}> Please try again</a>
        </div>
    )
);

export default Status;



// WEBPACK FOOTER //
// ./components/subscribe/Status.js